import { store } from '../../Redux/store';
import { ApiCall } from './CustomHooks';
import { setTranslations } from '../../Redux/Services/settingSlice';
import { retranslateAll } from './TranslationObserver';
import { setTranslationsCache } from './indexedDB';

let regexCache = null;
let lastDataRefRegex = null;

export const translateText = (text) => {
    try {
        if (!text || typeof text !== 'string') return text;
        const state = store.getState().settings;
        const lang = (state.currentLanguage || 'default').toLowerCase();

        if (lang === 'default' || !state.translations?.data?.length) return text;

        const match = text.match(/^(\s*)(.*?)(\s*)$/);
        if (!match) return text;

        const [, leading, coreText, trailing] = match;


        // For Exact Match
        // const found = state.translations.data.find(
        //     (t) => t.key && t.key.toLowerCase() === coreText.toLowerCase()
        // );

        // return found && found[lang] ? `${leading}${found[lang]}${trailing}` : text;


        // For GLobal match 
        // Build or use cached regex for single-pass replacement
        if (lastDataRefRegex !== state.translations.data) {
            const sortedKeys = state.translations.data
                .map(t => t.key)
                .filter(k => k && k.trim().length > 0)
                .sort((a, b) => b.length - a.length)
                .map(k => k.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));

            if (sortedKeys.length > 0) {
                // 'gi' for global and case-insensitive
                regexCache = new RegExp('(' + sortedKeys.join('|') + ')', 'gi');
            } else {
                regexCache = null;
            }
            lastDataRefRegex = state.translations.data;
        }

        if (!regexCache) return text;

        let hasMatch = false;
        const resultText = coreText.replace(regexCache, (matchedString) => {
            hasMatch = true;
            const lowerMatch = matchedString.toLowerCase();
            const found = state.translations.data.find(t => t.key?.toLowerCase() === lowerMatch);
            // Fallback to matchedString if translation not found for some reason
            return found && found[lang] ? found[lang] : matchedString;
        });

        return hasMatch ? `${leading}${resultText}${trailing}` : text;
    } catch (e) {
        return text;
    }
};

export const fetchGlobalTranslations = async () => {
    const payload = {
        "PageIndex": "1",
        "PageSize": "5000000",
        "Type": "S",
        "SearchText": "",
        "SearchFieldValue": "",
        "StartValue": "",
        "SortColumn": "",
        "SortOrder": "",
        "ActiveType": "",
        "PageName": "",
        "PendingLanguage": "",
        "Language": ""
    };
    try {
        const res = await ApiCall("/api/Master/ShowTranslationMaster", payload);
        if (res && res.Status === "SUCCESS" && res.Data) {
            const dynamicLangs = (res.HeadersValue || []).filter(
                k => !['TranslationID', 'Key', 'TotalRecord', 'TotalActive', 'TotalInActive', 'Focus'].includes(k)
            );

            const formattedTranslations = res.Data.map(item => {
                const transRow = { key: item.Key };
                dynamicLangs.forEach(lang => {
                    transRow[lang.toLowerCase()] = item[lang] || "";
                });
                return transRow;
            });

            const payloadData = { langs: dynamicLangs, data: formattedTranslations };
            store.dispatch(setTranslations(payloadData));
            setTranslationsCache(payloadData);
            retranslateAll();
        }
    } catch (err) {
        console.error("Failed to load translations:", err);
    }
};
